/* Torontech — Shopify Theme JS */
(function(){
  'use strict';
  const $ = (s, ctx=document) => ctx.querySelector(s);
  const $$ = (s, ctx=document) => [...ctx.querySelectorAll(s)];
  const fmt = new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:0});

  /* ---------- Mobile menu ---------- */
  const header = $('.header');
  const toggle = $('.menu-toggle');
  if (toggle && header) {
    toggle.addEventListener('click', () => {
      header.classList.toggle('is-open');
      const open = header.classList.contains('is-open');
      toggle.querySelector('.material-symbols-outlined').textContent = open ? 'close' : 'menu';
    });
  }

  /* ---------- Divisions dropdown: it's a hover container, not a link ---------- */
  $$('.divisions-toggle').forEach((a) => {
    a.addEventListener('click', (e) => e.preventDefault());
  });

  /* ---------- Priority nav: collapse overflow items into a "More" menu ---------- */
  const navEl = $('.nav');
  if (navEl) {
    const cta = $('.nav-cta', navEl);

    // Build the "More" dropdown (mirrors the existing mega-menu markup)
    const moreWrap = document.createElement('div');
    moreWrap.className = 'has-mega nav-more';
    moreWrap.hidden = true;
    moreWrap.innerHTML =
      '<a href="#" class="nav-more-toggle" aria-haspopup="true" aria-expanded="false">More' +
      '<span class="material-symbols-outlined">expand_more</span></a>' +
      '<div class="mega mega-more" role="menu"></div>';
    const morePanel = $('.mega-more', moreWrap);
    const moreToggle = $('.nav-more-toggle', moreWrap);
    moreToggle.addEventListener('click', (e) => e.preventDefault());

    // Items eligible to be collapsed = everything except the CTA and the
    // (mobile-only) language selector, in original order.
    const items = $$(':scope > *', navEl).filter(
      (el) => el !== cta && !el.classList.contains('lang-switcher')
    );
    navEl.insertBefore(moreWrap, cta || null);

    // Accordion behaviour for collapsed mega items inside the More panel
    morePanel.addEventListener('click', (e) => {
      const trigger = e.target.closest('.has-mega > a');
      if (trigger && morePanel.contains(trigger)) {
        e.preventDefault();
        trigger.parentElement.classList.toggle('is-expanded');
      }
    });

    const isDesktop = () => window.matchMedia('(min-width: 761px)').matches;
    const overflowing = () => navEl.scrollWidth > navEl.clientWidth + 1;

    const fit = () => {
      // Reset: return every item to the nav, collapse the More menu
      items.forEach((el) => navEl.insertBefore(el, moreWrap));
      moreWrap.hidden = true;

      if (!isDesktop()) return; // mobile uses the stacked dropdown menu

      // The absolutely-positioned dropdown panels (mega / flyout) overflow the
      // nav to the right and would inflate scrollWidth, making the bar look
      // overflowed when it isn't. Hide them while measuring real item widths.
      const panels = $$('.mega, .flyout', navEl);
      panels.forEach((p) => { p.dataset.pnDisplay = p.style.display; p.style.display = 'none'; });

      // Move trailing items into "More" until everything fits on one line
      for (let i = items.length - 1; i >= 0 && overflowing(); i--) {
        moreWrap.hidden = false;
        morePanel.insertBefore(items[i], morePanel.firstChild);
      }
      if (!morePanel.children.length) moreWrap.hidden = true;

      panels.forEach((p) => { p.style.display = p.dataset.pnDisplay || ''; delete p.dataset.pnDisplay; });
    };

    let raf;
    const onResize = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(fit); };
    window.addEventListener('resize', onResize, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    fit();

    // Mobile: tap a parent with children to expand/collapse its submenu
    navEl.addEventListener('click', (e) => {
      if (isDesktop()) return;
      const trigger = e.target.closest('.has-mega > a, .division-item.has-flyout > a');
      if (!trigger || !navEl.contains(trigger)) return;
      const parent = trigger.parentElement;
      const panel = parent.querySelector(':scope > .mega, :scope > .flyout');
      if (!panel) return;
      e.preventDefault();
      parent.classList.toggle('is-expanded');
    });
  }

  /* ---------- Language selector: close on outside click / Esc ---------- */
  const langDds = $$('.lang-dd');
  if (langDds.length) {
    document.addEventListener('click', (e) => {
      langDds.forEach((dd) => {
        if (dd.open && !dd.contains(e.target)) dd.open = false;
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      langDds.forEach((dd) => { if (dd.open) dd.open = false; });
    });
  }

  /* ---------- Sticky header shrink-on-scroll ---------- */
  if (header && header.classList.contains('header--shrink')) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Hero slider ---------- */
  const heroTrack = $('.hero-track');
  if (heroTrack) {
    const slides = $$('.hero-slide', heroTrack);
    const dots = $$('.hero-dots button');
    const prev = $('.hero-arrows .prev');
    const next = $('.hero-arrows .next');
    let i = 0;
    let timer = null;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
    };
    const nextSlide = () => go(i + 1);
    const start = () => { stop(); timer = setInterval(nextSlide, 6500); };
    const stop = () => { if (timer) clearInterval(timer); };
    dots.forEach((d, idx) => d.addEventListener('click', () => { go(idx); start(); }));
    prev && prev.addEventListener('click', () => { go(i - 1); start(); });
    next && next.addEventListener('click', () => { go(i + 1); start(); });
    heroTrack.addEventListener('mouseenter', stop);
    heroTrack.addEventListener('mouseleave', start);
    go(0);
    start();
  }

  /* ---------- Marquee duplication ---------- */
  $$('.marquee-track').forEach(track => {
    track.innerHTML = track.innerHTML + track.innerHTML;
  });

  /* ---------- Rich text: make wide tables scrollable ---------- */
  $$('.rte table').forEach(table => {
    const parent = table.parentElement;
    if (parent && parent.classList.contains('rte-table-wrap')) return;
    const wrap = document.createElement('div');
    wrap.className = 'rte-table-wrap';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach(group => {
    const buttons = $$('[data-tab]', group);
    const panels = $$('[data-panel]', group);
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.getAttribute('data-tab');
        buttons.forEach(b => b.classList.toggle('is-active', b === btn));
        panels.forEach(p => p.classList.toggle('is-active', p.getAttribute('data-panel') === target));
      });
    });
  });

  /* ---------- PDP gallery ---------- */
  const mainImg = $('.gallery-main img');
  if (mainImg) {
    $$('.thumb').forEach(t => {
      t.addEventListener('click', () => {
        $$('.thumb').forEach(x => x.classList.remove('is-active'));
        t.classList.add('is-active');
        const img = t.querySelector('img');
        if (img) {
          mainImg.src = img.getAttribute('data-full') || img.src;
          mainImg.alt = img.alt;
        }
      });
    });
  }

  /* ---------- PDP variant selection (buttons or dropdown) ---------- */
  // Keep the headline price + compare-at in sync with the chosen variant.
  const syncPdpPrice = (data) => {
    const priceEl = $('[data-pdp-price]');
    const compareEl = $('[data-pdp-compare]');
    const stickyPriceEl = $('[data-pdp-sticky-price]');
    if (priceEl && data.variantPrice) priceEl.textContent = data.variantPrice;
    if (stickyPriceEl && data.variantPrice) stickyPriceEl.textContent = data.variantPrice;
    if (compareEl) {
      if (data.variantCompare) {
        compareEl.textContent = data.variantCompare;
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }
  };

  // Button-style selector
  $$('.swatches').forEach(group => {
    $$('.swatch', group).forEach(sw => {
      sw.addEventListener('click', () => {
        $$('.swatch', group).forEach(x => x.classList.remove('is-active'));
        sw.classList.add('is-active');
        const form = group.closest('form');
        const idInput = form && form.querySelector('input[name="id"]');
        if (idInput && sw.dataset.variantId) idInput.value = sw.dataset.variantId;
        syncPdpPrice(sw.dataset);
      });
    });
  });

  // Dropdown-style selector (the <select> is itself the name="id" field)
  $$('.variant-select').forEach(sel => {
    sel.addEventListener('change', () => {
      const opt = sel.options[sel.selectedIndex];
      if (opt) syncPdpPrice(opt.dataset);
    });
  });

  /* ---------- PDP sticky buy bar (mobile) ---------- */
  const stickyBar = $('[data-pdp-sticky]');
  if (stickyBar) {
    // Anchor on whichever CTA this template actually renders.
    const primaryCta = $('[data-add-to-cart]') || $('.pdp-quote-btn');

    if (primaryCta && 'IntersectionObserver' in window) {
      const stickyIo = new IntersectionObserver(entries => {
        entries.forEach(e => {
          // Show only once the real CTA has scrolled off the top — not while it is
          // still below the fold on first paint.
          const scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
          stickyBar.hidden = !scrolledPast;
        });
      }, { threshold: 0 });
      stickyIo.observe(primaryCta);
    }

    const stickyAdd = $('[data-pdp-sticky-add]', stickyBar);
    if (stickyAdd && primaryCta) {
      stickyAdd.addEventListener('click', () => primaryCta.click());
    }
  }

  /* ---------- Quantity steppers ---------- */
  $$('.qty').forEach(group => {
    const input = group.querySelector('input');
    if (!input) return;
    group.querySelectorAll('button[data-step]').forEach(btn => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.getAttribute('data-step'), 10);
        const cur = Math.max(1, parseInt(input.value || '1', 10) + step);
        input.value = cur;
        input.dispatchEvent(new Event('change', {bubbles:true}));
      });
    });
  });

  /* ---------- Collection: view toggle ---------- */
  $$('.view-toggle').forEach(grp => {
    grp.querySelectorAll('button').forEach(b => {
      b.addEventListener('click', () => {
        grp.querySelectorAll('button').forEach(x => x.classList.remove('is-active'));
        b.classList.add('is-active');
        const grid = $('.coll-grid');
        if (!grid) return;
        if (b.getAttribute('data-view') === 'list') grid.classList.add('list-view');
        else grid.classList.remove('list-view');
      });
    });
  });

  /* ---------- Collection: mobile filter toggle ---------- */
  const filterToggle = $('.filter-mobile-toggle');
  const filters = $('.filters');
  if (filterToggle && filters) {
    filterToggle.addEventListener('click', () => {
      const hidden = filters.hasAttribute('hidden');
      if (hidden) filters.removeAttribute('hidden'); else filters.setAttribute('hidden','');
    });
  }

  /* ---------- Collection: auto-apply facet filters ---------- */
  const filterForm = $('#CollectionFilterForm');
  if (filterForm) {
    const submitFilters = () => {
      // Drop empty price inputs so they don't add blank query params to the URL.
      filterForm.querySelectorAll('input[type="number"]').forEach(inp => {
        inp.disabled = inp.value.trim() === '';
      });
      filterForm.submit();
    };
    filterForm.addEventListener('change', (e) => {
      if (e.target.matches('input[type="checkbox"], select')) submitFilters();
    });
    // Price fields: apply on Enter or when the field loses focus with a new value.
    filterForm.querySelectorAll('.filter-price-input').forEach(inp => {
      inp.addEventListener('change', submitFilters);
      inp.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { e.preventDefault(); submitFilters(); }
      });
    });
  }

  /* ---------- Collection: chips remove ---------- */
  $$('.chips .chip').forEach(c => {
    c.addEventListener('click', () => c.remove());
  });

  /* ---------- Shopify AJAX Cart ---------- */
  const money = val => `$${Math.round(val).toLocaleString()}`;

  function toast(msg, icon='check_circle') {
    let toastEl = $('#global-toast');
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.id = 'global-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = `<span class="material-symbols-outlined">${icon}</span> ${msg}`;
    toastEl.classList.add('is-show');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toastEl.classList.remove('is-show'), 2400);
  }

  /* AJAX Add to Cart */
  $$('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const form = btn.closest('form');
      if (!form) return;
      const formData = new FormData(form);
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
      .then(res => res.json().then(data => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) {
          toast(data.description || data.message || 'Could not add to cart', 'error');
          return;
        }
        toast('Added to cart');
        updateCartCount();
      })
      .catch(() => {
        toast('Could not add to cart', 'error');
      })
      .finally(() => { btn.disabled = false; });
    });
  });

  /* Update cart count badge */
  function updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const badges = $$('.badge');
        badges.forEach(b => {
          b.textContent = cart.item_count;
          b.style.display = cart.item_count > 0 ? 'grid' : 'none';
        });
      });
  }
  updateCartCount();

  /* Cart page: quantity updates via AJAX */
  function recalcCart() {
    const items = $$('.cart-item[data-line]');
    if (!items.length) return;
    items.forEach(item => {
      const line = item.dataset.line;
      const input = item.querySelector('input.qty-input');
      if (!input) return;
      const qty = Math.max(1, parseInt(input.value || '1', 10));
      input.value = qty;
    });
  }

  $$('.cart-item input.qty-input').forEach(inp => {
    inp.addEventListener('change', function() {
      const line = this.closest('.cart-item').dataset.line;
      const qty = Math.max(1, parseInt(this.value || '1', 10));
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({line: line, quantity: qty})
      }).then(() => { window.location.reload(); });
    });
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const targets = $$('[data-reveal]');
    targets.forEach(el => el.classList.add('reveal-init'));
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      });
    }, {threshold:.01, rootMargin:'0px 0px -10% 0px'});
    targets.forEach(el => io.observe(el));
    setTimeout(() => targets.forEach(el => el.classList.add('is-revealed')), 1500);
  }

  /* ---------- Collection description: read more / read less ---------- */
  $$('[data-collection-description]').forEach((wrap) => {
    const body = $('.collection-description-body', wrap);
    const toggle = $('.collection-description-toggle', wrap);
    if (!body || !toggle) return;
    wrap.classList.add('is-clamped');
    requestAnimationFrame(() => {
      if (body.scrollHeight > body.clientHeight + 1) {
        toggle.hidden = false;
      } else {
        wrap.classList.remove('is-clamped');
      }
    });
    toggle.addEventListener('click', () => {
      const collapse = !wrap.classList.contains('is-clamped');
      wrap.classList.toggle('is-clamped', collapse);
      toggle.textContent = collapse ? toggle.dataset.readMore : toggle.dataset.readLess;
    });
  });

  /* ---------- Year token ---------- */
  $$('[data-year]').forEach(el => el.textContent = new Date().getFullYear());

  /* ---------- Search Popup Modal & Predictive Search ---------- */
  const searchTrigger = $('.btn-icon[aria-label="Search"]');
  const searchModal = $('#search-modal');
  const searchInput = $('.search-modal-input');
  const searchResults = $('#search-results-container');
  const searchClose = $('.search-modal-close');
  const searchOverlay = $('.search-modal-overlay');
  const searchShowPrice = searchModal && searchModal.dataset.showPrice === 'true';

  if (searchTrigger && searchModal) {
    // Keep the dropdown flush under the (possibly sticky/shrunk) header so it
    // never overlaps the topbar/nav instead of sitting right below it.
    const updateSearchModalOffset = () => {
      const headerEl = $('.header');
      if (!headerEl) return;
      const offset = Math.max(0, Math.round(headerEl.getBoundingClientRect().bottom));
      searchModal.style.setProperty('--search-modal-offset', offset + 'px');
    };

    searchTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      updateSearchModalOffset();
      searchModal.classList.add('is-active');
      searchModal.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      setTimeout(() => searchInput.focus(), 150);
    });

    window.addEventListener('resize', () => {
      if (searchModal.classList.contains('is-active')) updateSearchModalOffset();
    });

    const closeSearch = () => {
      searchModal.classList.remove('is-active');
      searchModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      searchInput.value = '';
      searchResults.innerHTML = '';
    };

    searchClose && searchClose.addEventListener('click', closeSearch);
    searchOverlay && searchOverlay.addEventListener('click', closeSearch);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeSearch();
    });

    let debounceTimer = null;
    searchInput.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      const query = searchInput.value.trim();
      if (query.length < 2) {
        searchResults.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(() => {
        // Shopify Predictive Search API endpoint
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
          .then(res => res.json())
          .then(data => {
            const products = data.resources.results.products;
            if (products && products.length > 0) {
              let html = '<div class="search-results-heading">Suggested Products</div><div class="search-results-list">';
              products.forEach(p => {
                const amount = parseFloat(p.price);
                const formattedPrice = isNaN(amount) || amount <= 0 ? '' : fmt.format(amount);
                html += `
                  <a href="${p.url}" class="search-result-item">
                    <div class="sri-img">
                      <img src="${p.image || 'https://cdn.shopify.com/s/files/1/0710/5291/9023/files/logo.png?v=1780472635'}" alt="${p.title}">
                    </div>
                    <div class="sri-info">
                      <span class="sri-title">${p.title}</span>
                      ${searchShowPrice && formattedPrice ? `<span class="sri-price">${formattedPrice}</span>` : ''}
                    </div>
                    <span class="material-symbols-outlined sri-arrow">arrow_forward</span>
                  </a>
                `;
              });
              html += '</div>';
              searchResults.innerHTML = html;
            } else {
              searchResults.innerHTML = '<div class="search-no-results">No products found matching your search.</div>';
            }
          })
          .catch(err => {
            console.error('Error fetching search suggestions:', err);
          });
      }, 250);
    });
  }

  /* ---------- Request a Quote Modal (accessible dialog) ---------- */
  const quoteModal = $('#quote-request-modal');
  if (quoteModal) {
    const qrOverlay = $('.qr-modal-overlay', quoteModal);
    const qrDialog = $('.qr-modal-content', quoteModal);
    const qrCloseBtns = $$('[data-qr-close]', quoteModal);
    const qrOpenBtns = $$('[data-qr-open]');
    const qrForm = $('#quote-request-form', quoteModal);
    const qrSuccess = $('#quote-form-success', quoteModal);
    const qrError = $('#quote-form-error', quoteModal);
    const qrSubmitBtn = $('#quote-submit-btn', quoteModal);
    const qrSubmitLabel = qrSubmitBtn && $('.qr-submit-btn-label', qrSubmitBtn);
    const QR_FOCUSABLE_SEL =
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    let qrLastFocused = null;

    const qrFocusable = () => $$(QR_FOCUSABLE_SEL, qrDialog).filter(el => el.offsetParent !== null);

    function qrReset() {
      if (qrSuccess) qrSuccess.hidden = true;
      if (qrError) qrError.hidden = true;
      if (qrForm) {
        qrForm.hidden = false;
        qrForm.reset();
      }
    }

    function qrOnKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        qrClose();
        return;
      }
      if (e.key !== 'Tab') return;
      const focusables = qrFocusable();
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    const qrDesc = $('#quote-modal-desc', quoteModal);
    const qrDescTemplate = qrDesc ? qrDesc.getAttribute('data-qr-desc-template') || '' : '';
    const qrProductInput = $('[data-qr-product-input]', quoteModal);
    const qrProductLink = $('[data-qr-product-link]', quoteModal);

    function qrSetProduct(trigger) {
      const data = (trigger && trigger.dataset) || {};
      const title = data.productTitle || '';
      const url = data.productUrl || '';
      if (qrDesc && qrDescTemplate) qrDesc.textContent = qrDescTemplate.replace('%%PRODUCT%%', title);
      if (qrProductInput) qrProductInput.value = title;
      if (qrProductLink) qrProductLink.value = url ? window.location.origin + url : window.location.href;
    }

    function qrOpen(trigger) {
      qrLastFocused = trigger || document.activeElement;
      qrReset();
      qrSetProduct(trigger);
      quoteModal.classList.add('is-active');
      quoteModal.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', qrOnKeydown, true);
      const focusables = qrFocusable();
      (focusables[0] || qrDialog).focus();
    }

    function qrClose() {
      quoteModal.classList.remove('is-active');
      quoteModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', qrOnKeydown, true);
      if (qrLastFocused && typeof qrLastFocused.focus === 'function') qrLastFocused.focus();
    }

    qrOpenBtns.forEach(btn => btn.addEventListener('click', () => qrOpen(btn)));
    qrCloseBtns.forEach(btn => btn.addEventListener('click', qrClose));
    qrOverlay && qrOverlay.addEventListener('click', qrClose);

    if (qrForm) {
      const qrLoadTime = Date.now();

      qrForm.addEventListener('submit', async function (e) {
        e.preventDefault();
        if (qrSuccess) qrSuccess.hidden = true;
        if (qrError) qrError.hidden = true;

        const proxyUrl = (qrForm.dataset.proxyUrl || '').replace(/\/$/, '');
        const originalLabel = qrSubmitLabel ? qrSubmitLabel.textContent : null;
        qrSubmitBtn.disabled = true;
        if (qrSubmitLabel) qrSubmitLabel.textContent = qrSubmitBtn.dataset.sendingText || 'Sending...';

        try {
          const formDataObj = {};
          const fd = new FormData(qrForm);
          for (const [key, value] of fd.entries()) formDataObj[key] = value;
          formDataObj.retURL = window.location.href;

          const submitTime = Math.round((Date.now() - qrLoadTime) / 1000);
          const payload = {
            IS_TORONTECH: true,
            tenant: 'torontech',
            formData: formDataObj,
            senderEmail: formDataObj.email || '',
            senderName: (formDataObj.first_name || '') + ' ' + (formDataObj.last_name || ''),
            message: formDataObj.description || '',
            submitTime: submitTime,
          };

          const response = await fetch(proxyUrl + '/api/webhook/lead', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });

          const result = await response.json();

          if (result.success) {
            if (qrForm) qrForm.hidden = true;
            if (qrSuccess) {
              qrSuccess.hidden = false;
              qrSuccess.focus();
            }
          } else if (qrError) {
            qrError.hidden = false;
            qrError.focus();
          }
        } catch (err) {
          console.error('Quote request submission error:', err);
          if (qrError) {
            qrError.hidden = false;
            qrError.focus();
          }
        } finally {
          qrSubmitBtn.disabled = false;
          if (qrSubmitLabel && originalLabel !== null) qrSubmitLabel.textContent = originalLabel;
        }
      });
    }
  }
})();
